import { Editor as TinyMCEEditor } from 'tinymce';
import {
  removeDataAttributes,
  removeHtmlComments,
  removeHtmlDirectives,
  removePopupImageFragments,
  removeSearchListTable,
} from '../../../../../../lib/HtmlSanitization/htmlSanitization';
import { normalizeHtml } from '../../../../../../lib/Pipes/pipes';

import { removeControlCharacters } from '../../../../../../_lib/StringUtils';

// safe list is defined in several places:
// - tinyConfiguration.js
// - de.bund.officenet.keycloak.themeConfigSpi.SpiHtmlFeatureSet
// - de.bund.officenet.son.service.validation.SonHtmlFeatureSet
export const approvedDataAttributes = [
  'data-resource-reference',
  'data-breed',
  'data-link-type',
  'data-file-size',
  'data-anchor',
  'data-forecolor',
  'data-hint-language-key',
];

export function pastePreprocess(plugin: any, args: any) {
  /* Overwrite args.content as suggested in the tiny mce documentation
   * (https://www.tiny.cloud/docs/plugins/paste/#paste_preprocess) */

  args.content = removeControlCharacters(
    normalizeHtml(
      args.content,
      removeHtmlComments,
      removeHtmlDirectives,
      removeSearchListTable,
      removePopupImageFragments,
      removeDataAttributes(approvedDataAttributes),
    ),
  );
}

/**
 * some custom data-* attributes will not be removed
 *  -> see https://github.com/tinymce/tinymce/blob/develop/modules/tinymce/CHANGELOG.md#fixed-2
 */
function cleanCustomAttributesOnPostProcess(html: HTMLHtmlElement): void {
  html.querySelectorAll('[data-forecolor]').forEach(element => element.removeAttribute('data-forecolor'));
}

/**
 * tiny does not remove aria-label ( or i think any aria-* ) attribute when saving, although
 * we do not define them in valid_elements list -> see github.com/tinymce/tinymce/issues/8515
 * so we clean them when copying from somewhere
 */
function cleanAriaLabelsOnLists(html: HTMLHtmlElement): void {
  const selectors = ['ul[aria-label]', 'ol[aria-label]', 'li[aria-label]'].join(', ');
  html.querySelectorAll(selectors).forEach(element => element.removeAttribute('aria-label'));
}

/**
 * clean on paste.
 * tiny already transforms the pasted text to html here, so we dont need cheerio !
 */
export function pastePostProcess(editor: any, args: any): void {
  const html = args.node as HTMLHtmlElement;
  cleanCustomAttributesOnPostProcess(html);
  cleanAriaLabelsOnLists(html);
}

export const getTextContent = (editorInstance: TinyMCEEditor | null): string => {
  return editorInstance ? editorInstance.getContent({ format: 'text' }) : '';
};
